import { ConnectorCardReducerAction, ConnectorCardReducerState } from '@/types/reducers';

export function connectorCardReducer(
  state: ConnectorCardReducerState,
  action: ConnectorCardReducerAction,
): ConnectorCardReducerState {
  switch (action.type) {
    case 'UNDER_SETUP':
      if (state.status === 'Init' || state.status === 'Failure')
        return {
          status: 'Under_Setup',
          isLoading: true,
          isActive: action.payload.isActive,
        };
      return state;
    case 'SUCCESS':
      if (
        state.status === 'Under_Setup' ||
        state.status === 'Init' ||
        state.status === 'Activating' ||
        state.status === 'Deactivating' ||
        state.status === 'Syncing'
      )
        return { status: 'Success', isLoading: false, isActive: action.payload.isActive };
      return state;
    case 'FAILURE':
      if (
        state.status === 'Under_Setup' ||
        state.status === 'Init' ||
        state.status === 'Deleting'
      )
        return {
          status: 'Failure',
          errorType: action.payload.errorType,
          isLoading: false,
          isActive: action.payload.isActive,
        };
      return state;
    case 'ACTIVATING':
      if (state.status === 'Success')
        return {
          status: 'Activating',
          isLoading: true,
          isActive: action.payload.isActive,
        };
      return state;
    case 'DEACTIVATING':
      if (state.status === 'Success')
        return {
          status: 'Deactivating',
          isLoading: true,
          isActive: action.payload.isActive,
        };
      return state;
    case 'SYNCING':
      if (state.status === 'Success')
        return { status: 'Syncing', isLoading: false, isActive: action.payload.isActive };
      return state;
    case 'DELETING':
      if (state.status === 'Success')
        return { status: 'Deleting', isLoading: true, isActive: action.payload.isActive };
      return state;
    default:
      throw new Error(`Unknown action type`);
  }
}
